import { PlotData, Layout } from './graph-data-response';

export abstract class PlotlyGraph {
    plotData: PlotData[] = [];
    layout: Layout = {};
    hasDashboardSupport: boolean = true;
    needsFirmwareUpdate: boolean = false;
}
